module.exports = "/_next/static/videos/portals-animation-7e38e743c6ad4d071204e1c1f89f6d11.mp4";